import { useTranslation } from "react-i18next";
import { OldValue } from "../../../../helpers/historyHelpers/components/OldValue";
import { NewValue } from "../../../../helpers/historyHelpers/components/NewValue";
import { Label } from "../../../../helpers/historyHelpers/components/Label";

const fields = ["allowSegmentation", "description", "forSchedule", "status"];

const RenderItem = ({ data }) => {
    const { t } = useTranslation();

    if (!data) return null;

    const renderValues = (item, data) => {
        const newValue = data[item]?.new;
        const oldValue = data[item]?.old;

        switch (item) {
            case "allowSegmentation":
            case "forSchedule":
                return (
                    <>
                        {typeof oldValue === "boolean" && (
                            <OldValue value={oldValue ? t("active") : t("not-active")} />
                        )}
                        {typeof newValue === "boolean" && (
                            <NewValue value={newValue ? t("active") : t("not-active")} />
                        )}
                    </>
                );
            case "description":
            case "status":
                return (
                    <>
                        {oldValue && <OldValue value={t(oldValue)} />}
                        {newValue && <NewValue value={t(newValue)} />}
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="tooltip-content-style text-left">
            {fields.map((item) => {
                if (!data[item]) return null;

                return (
                    <div key={item}>
                        <div className="py-1 d-flex align-items-center gap-2">
                            <Label value={t(item)} /> {renderValues(item, data)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default RenderItem;
